const saveInLocalStorage = (keyName: string, value: string) => {
  window.localStorage.setItem(keyName, value);
};

const readFromLocalStorage = (keyName: string) => window.localStorage.getItem(keyName);

export { readFromLocalStorage, saveInLocalStorage };
